// Port of api/fuel/app/classes/filter/package/games/rating.php
import CommentsData from 'offline/filter/package/games/rating/data/comments'
import RevisionsData from 'offline/filter/package/games/rating/data/revisions'
import RatingPrepare from 'offline/filter/package/games/rating/prepare/rating'
import CommentPackage from 'offline/filter/package/games/rating/package/comment'
import RatingPackage from 'offline/filter/package/games/rating/package/rating'
import RecentPackage from 'offline/filter/package/games/rating/package/recent'
import RevisionsPackage from 'offline/filter/package/games/rating/package/revisions'
import TrendPackage from 'offline/filter/package/games/rating/package/trend'

function sortUnits(units) {
	return units.slice().sort(function(a, b) {
		return (a.priority || 0) - (b.priority || 0)
	})
}

function runPrepare(units, local, global, config, filter) {
	var prepared = Object.assign({}, local)
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(prepared, global, config, filter)
		if (result !== undefined) prepared = result
	}

	return prepared
}

function runPackage(units, prepared, global, config, filter) {
	var pkg = {}
	var sorted = sortUnits(units)

	for (var i = 0; i < sorted.length; i++) {
		var unit = sorted[i]
		if (unit.require && !unit.require(config, filter, null, global)) continue
		var result = unit.run(pkg, prepared, global, config, filter)
		if (result !== undefined) pkg = result
	}

	return pkg
}

export default {
	data_units: [CommentsData, RevisionsData],
	prepare_units: [RatingPrepare],
	package_units: [CommentPackage, RatingPackage, RecentPackage, RevisionsPackage, TrendPackage],

	run: function(resultId, local, global, config, filter) {
		var prepared = runPrepare(this.prepare_units, local, global, config, filter)
		var pkg = runPackage(this.package_units, prepared, global, config, filter)
		pkg.id = resultId
		return pkg
	}
}
